export default "__VITE_ASSET__Bpjlsiqv__"